import * as React from "react";
const SvgUpdateManualIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16 18V20H8V18H16ZM11 7.99V16H13V7.99H16L12 4L8 7.99H11Z", fill: "currentColor" }));
export default SvgUpdateManualIcon;
